import './bootstrap.css';
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.css";
import { ClerkProvider } from "@clerk/clerk-react";

import { createStore } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";

// store
const store = createStore(rootReducer, composeWithDevTools());

// Get the Clerk Key securely from your .env file
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) {
  console.error("CRITICAL: REACT_APP_CLERK_PUBLISHABLE_KEY is missing from client/.env!");
}

// Customizing Clerk Text and Fonts
const clerkAppearance = {
  variables: {
    // Inherits the exact font family and styling your app uses
    fontFamily: "inherit",
  },
};

const clerkLocalization = {
  signIn: {
    start: { subtitle: "to continue shopping" },
  },
  signUp: {
    start: { subtitle: "to continue shopping" },
  },
};

ReactDOM.render(
  // <React.StrictMode>
  <ClerkProvider publishableKey={PUBLISHABLE_KEY} appearance={clerkAppearance} localization={clerkLocalization}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ClerkProvider>,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
